import React from "react";
import "./style.scss";

const EmptyData = ({ title }) => {
  return (
    <div className="no-data-component">
      <span>{title}</span>
    </div>
  );
};

export default EmptyData;
